<template>
    <div id="wrapper" class="wrapper">
        <!-- 1. 路由匹配到的组件将渲染在这里 -->
        <div class="wrapper-content">
            <router-view></router-view>
        </div>
        <!-- 1.2 底部菜单栏:非web端 -->
        <bottom-menu-bar v-if="$route.meta.showFooter"></bottom-menu-bar>
        <!-- 1.3 活动按钮 -->
        <!-- 998弹框悬浮按钮入口 -->
        <div class="activity-btn-box" v-if="showActSixOneEightBtn" @click="clickActivity">
            <div class="activity-btn-bg" :style="activityInfo ? 'background-image: url('+activityInfo.entry+')' : ''">
                <div class="activity-time-cd">{{activityInfo.show_type == 1 ? actCountDownTimeStr2 : '剩'+actCountDownNumber+'个名额'}}</div>
            </div>
        </div>
        <!-- 648弹框悬浮按钮入口 -->
        <div class="activity-btn-box activity-btn-box-newuser" v-if="showActNewUserBtn" @click="clickNewUserActivity">
            <div class="activity-btn-bg" :style="newUserActivityInfo ? 'background-image: url('+newUserActivityInfo.entry+')' : ''">
                <div class="activity-time-cd">{{newUserCountDownTimeStr1}}</div>
            </div>
        </div>
        <!-- 1.4 测算优化悬浮按钮 -->
        <report-act-btn></report-act-btn>

        <!-- 2. loading层 -->
        <div id="loading" class="layout-overlay layout-overlay-blank loading-page" style="display: none">
            <div class="loading-content">
                <div class="lds-default-gray-box">
                    <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
            </div>
        </div>

        <!-- 3. 下载APP提示弹框 -->
        <reminder-download v-if="showDownloadReminder"></reminder-download>

        <!-- 4. 版本更新提示弹框 -->
        <reminder-version v-if="showVersionReminder"></reminder-version>

        <!-- 5. 解锁VIP弹框 -->
        <vant-vip-pay-pop></vant-vip-pay-pop>
        <!-- 6. 解锁VIP成功后弹框 -->
        <vant-vip-suc-pop></vant-vip-suc-pop>
        <!-- 7. VIP主页面弹框 -->
        <my-vip></my-vip>
        <!-- 8. VIP限量活动入口按钮 -->
        <my-vip-act-btn v-if="!showMyVip && showVipPop && $route.meta.showFooter"></my-vip-act-btn>
        <!-- 9. 活动弹框 2023年618活动-->
        <vant-activity-six-one-eight-pop></vant-activity-six-one-eight-pop>
        <vant-activity-six-one-eight-second-pop></vant-activity-six-one-eight-second-pop>
        <!-- 9.1 活动弹框 1388终生会员弹框-->
        <vant-activity-always-discount-pop></vant-activity-always-discount-pop>
        <!-- 9.2 活动弹框 新注册用户弹框-->
        <vant-activity-new-user-pop></vant-activity-new-user-pop>
        <vant-activity-new-user-second-pop></vant-activity-new-user-second-pop>
        <!-- 9.3 活动弹框 dayLuck弹框-->
        <vant-activity-day-luck-pop></vant-activity-day-luck-pop>
        <!-- 10. 活动弹框 测算支付优化弹框-->
        <report-act-popup></report-act-popup>
        <!-- 11. 活动弹框 课程中心活动弹框 -->
        <course-act-popup></course-act-popup>
        <!-- 12. 授权登录提示todo UI设计一下？ -->
        <van-popup class="remind-auth-pop-box" position="bottom" :value="showAuthRemind" :close-on-click-overlay=false >
            <div class="remind-auth-pop-content">请点击右下角授权登录再使用完整功能</div>
        </van-popup>

        <!-- ds弹框 -->
        <deep-seek-popup></deep-seek-popup>
        <deep-seek-pay-popup></deep-seek-pay-popup>
    </div>
</template>
<script>
import BottomMenuBar from './components/BottomMenuBar.vue'
import ReminderDownload from './layouts/reminder/ReminderDownload.vue'
import ReminderVersion from './layouts/reminder/ReminderVersion.vue'
import VantVipPayPop from './layouts/vant/VantVipPayPop.vue'
import VantVipSucPop from './layouts/vant/VantVipSucPop.vue'
import MyVip from './pages/my/MyVip.vue'
import MyVipActBtn from './components/my/MyVipActBtn.vue'
import VantActivitySixOneEightPop from './layouts/activity/VantActivitySixOneEightPop.vue'
import VantActivitySixOneEightSecondPop from './layouts/activity/VantActivitySixOneEightSecondPop.vue'
import VantActivityAlwaysDiscountPop from './layouts/activity/VantActivityAlwaysDiscountPop.vue'
import VantActivityNewUserPop from './layouts/activity/VantActivityNewUserPop.vue'
import VantActivityNewUserSecondPop from './layouts/activity/VantActivityNewUserSecondPop.vue'
import VantActivityDayLuckPop from './layouts/activity/VantActivityDayLuckPop.vue'
import ReportActBtn from './layouts/report/ReportActBtn.vue'
import ReportActPopup from './layouts/report/ReportActPopup.vue'
import CourseActPopup from './layouts/course/CourseActPopup.vue'
import { CONFIG } from './modules/config'
import { MIX, UA, UTILS } from './modules/utils'
import { SHARE } from './modules/share'
export default {
    name: "App",
    components: { BottomMenuBar, ReminderDownload, ReminderVersion, VantVipPayPop, VantVipSucPop, MyVip, MyVipActBtn, 
            VantActivitySixOneEightPop, VantActivitySixOneEightSecondPop, VantActivityAlwaysDiscountPop, 
            VantActivityNewUserPop, VantActivityNewUserSecondPop, VantActivityDayLuckPop, ReportActBtn, ReportActPopup, CourseActPopup },
    computed: {
        showDownloadReminder() {
            return this.$store.state.reminder.showDownloadReminder
        },
        showVersionReminder() {
            return this.$store.state.reminder.showVersionReminder
        },
        showWebFamousPediaPop() {
            return this.$store.state.weblogin.showWebFamousPediaPop
        },
        showMyVip() {
            return this.$store.state.user.showMyVip;
        },
        showVipPop() {
            return this.$store.state.reminder.showVipPop;
        },
        activityInfo() {
            return this.$store.state.activity.activityInfo;
        },
        showActSixOneEightBtn() {
            return this.$store.state.activity.showActSixOneEightBtn;
        },
        actCountDownTimeStr2() {
            return this.$store.state.activity.actCountDownTimeStr2;
        },
        actCountDownNumber() {
            return this.$store.state.activity.actCountDownNumber;
        },
        showActNewUserBtn() {
            return this.$store.state.activity.showActNewUserBtn;
        },
        newUserActivityInfo() {
            return this.$store.state.activity.newUserActivityInfo;
        },
        newUserCountDownTimeStr1() {
            return this.$store.state.activity.newUserCountDownTimeStr1;
        },
        showAuthRemind() {
            return this.$store.state.showAuthRemind;
        }
    },
    data() {
        return {
            CONFIG: CONFIG,
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            switch(CONFIG.platform) {
                case 'wechat':
                case 'wxcy':
                    me.initDom();
                    break;
                case 'qq':
                    me.initQQDom();
                    break;
                case 'web':
                    me.initWebDom();
                default:
                    break;
            }
            // me.initFontSize();
            me.initData();
            // me.initTest();
            me.checkEmbedded();
        }, 200);
    },
    methods: {
        initDom() {
            let path = this.$router.history.current.path;
            console.log('initDom------', path);
            if(path == '/') {
                // this.$nextTick(() => {
                //     window.scrollTo(0, 1)
                //     window.scrollTo(0, 0)
                // })
                
                SHARE.initConfigShare();
                setTimeout(() => {
                    this.$router.replace('/collate');
                }, 20);
            }
        },
        initFontSize() {
            if(UA.isAndroid()){
                var $dom = document.createElement('div');
                    $dom.style = 'font-size:10px;';
                document.body.appendChild($dom);
                // 计算出放大后的字体
                var scaledFontSize = parseInt(window.getComputedStyle($dom, null).getPropertyValue('font-size'));
                document.body.removeChild($dom);
                // 计算原字体和放大后字体的比例
                var scaleFactor = 10 / scaledFontSize;
                
                // 取html元素的字体大小
                // 注意，这个大小也经过缩放了
                // 所以下方计算的时候 *scaledFontSize是原来的html字体大小
                // 再次 *scaledFontSize才是我们要设置的大小
                var originRootFontSize = parseInt(window.getComputedStyle(document.documentElement, null).getPropertyValue('font-size'));
                document.documentElement.style.fontSize = originRootFontSize * scaleFactor * scaleFactor + 'px';
                console.log(originRootFontSize * scaleFactor * scaleFactor);
            }
        },
        initData() {
            var me = this;
            var curPath = this.$router.history.current.path,
                userInfo = this.$store.state.userData.info;
            console.log('App----initData-----', userInfo);

            let hideAct = curPath.indexOf('embedded') !== -1 || curPath.indexOf('diagram') !== -1 || curPath.indexOf('strong') !== -1 || (userInfo && userInfo.vip == 30);
            setTimeout(() => {
                console.log('App----initData-----', hideAct)
                this.$store.dispatch('activity/getActivityInfo', {hideAct: hideAct});
            }, 1000);
            // H5页面
            if(curPath.indexOf('embedded') == -1) {
                this.$store.dispatch('initBasicData');
                this.$store.dispatch('getBannerList');
                this.$store.dispatch('user/getVipActivityInfo');
                this.$store.dispatch('user/getVipDayLuckInfo');
                this.$store.dispatch('pay/getProductList', {
                    type: 0
                });
                if(userInfo) {
                    this.$store.dispatch('reminder/getAllExtList', {
                        vip: parseInt(userInfo.vip),
                        vipCb: function() {
                            var showVipPop = me.$store.state.reminder.showVipPop;
                            me.$store.state.user.showMyVip = showVipPop;
                            me.$store.state.user.curVipPayType = userInfo && parseInt(userInfo.donate) == 1 ? 3 : 4;
                            if(showVipPop) {
                                setTimeout(() => {
                                    me.$bus.emit('initMyVipPage');
                                    me.$bus.emit('startMyVipAni');
                                }, 20);
                                me.$store.state.reminder.showDownloadReminder = false;
                            }else {
                                me.$store.state.reminder.showDownloadReminder = true;
                            }
                        },
                        appCb: function() {
                            me.$store.state.reminder.showDownloadReminder = true;
                        },
                        vipCourseCb: (data)=> {
                            me.$store.dispatch('course/checkVipCourseStatus', {
                                configData: data,
                                userVip: parseInt(userInfo.vip)
                            });
                        }
                    });
                }
                // this.$store.state.reminder.showVersionReminder = true;
                setTimeout(() => {
                    this.$store.dispatch('report/getReportAIShowTime');
                }, 3000);

            }else {
            // H5嵌入页面
                this.$store.dispatch('setting/initSettingData');
                // let queryData = this.$store.state.embedded.queryData;
                // let platform = queryData.os && queryData.os.toLowerCase().indexOf('android') != -1 ? 2 : 5; //安卓为2,IOS为5
                // console.log('App----embedded----platform-----', platform);
                // this.$store.dispatch('pay/getProductList', {
                //     platform: platform, 
                //     type: 0
                // });
            }
        },
        initTest() {
            // UTILS.getTimeInfoByTimeString("2020-11-24 01:01:42");
            // this.$store.dispatch('reminder/udpateExtList', {
            //     params: {
            //         detailExtTime: {name:0, fate:0, share:0, label:0},
            //         collateExtTime: {float:0, label:0}
            //     }
            // });
            this.$store.dispatch('reminder/udpateExtList', {
                params: {
                    course_privilege_forever: 0, course_privilege_h5_forever: 0,
                    course_privilege_month: 0, course_privilege_h5_month: 0,
                    course_privilege_year: 0, course_privilege_h5_year: 0,
                }
            });
        },        
        checkEmbedded() {
            var curPath = this.$router.history.current.path;
            console.log('checkEmbedded-----', curPath)
            if(curPath.indexOf('embedded') != -1) {
                this.$store.state.reminder.showVersionReminder = false;
                this.$store.state.reminder.showDownloadReminder = false;
            }
            // 处理App分享的旧URL
            if(curPath.indexOf('connect/oauth2') == -1 && curPath.indexOf('share/discuss/muhuolph_') != -1) {
                curPath = curPath.replace('share/discuss/', 'share/discuss/discussmain/')
                SHARE.initConfigShare();
                this.$router.replace(curPath);
            }
            if(curPath.indexOf('connect/oauth2') == -1 && curPath.indexOf('share/discuss/muhuolp_') != -1) {
                curPath = curPath.replace('share/discuss/', 'share/discuss/discusslist/')
                SHARE.initConfigShare();
                this.$router.replace(curPath);
            }
        },
        initQQDom() {
            var paramsPath = UTILS.getQueryString('path'),
                curPath = this.$router.history.current.path;
            console.log('initQQDom--------', paramsPath, curPath)
            // 检查路径,并跳转到
            if(paramsPath) {
                // 如果没有二级目录的话就可以直接跳转
                if(paramsPath.indexOf('-') == -1) {
                    this.$router.replace('/' + paramsPath);
                }else {
                    // share-detail-muhuo_4017a0dc715b56aa42fb24babaadd682_512597-save0
                    if(paramsPath.indexOf('share-detail') != -1) {
                        paramsPath = paramsPath.replace('-', '/');
                        paramsPath = paramsPath.replace('-', '/');
                    }else {
                        paramsPath = paramsPath.replace(/-/g, '/')
                    }
                    this.$router.replace('/' + paramsPath);
                }
            }else {
                if(curPath == '/') {
                    SHARE.initConfigShare();
                    this.$router.replace('/home');
                }
            }
            if(curPath.indexOf('web') != -1) {
                var newPath = curPath.replace('/web', '');
                window.location.href = CONFIG.qq_url + newPath;
            }
        },
        initWebDom() {
            var curPath = this.$router.history.current.path;
            // console.error('initWebDom-------', curPath, this.$router)
            if(curPath == '/') {
                SHARE.initConfigShare();
                this.$router.replace('/webhome');
            }
        },
        clickWebFamousPediaOverlay() {
            this.$store.state.weblogin.showWebFamousPediaPop = false;
        },
        clickActivity() {
            this.$store.state.activity.showActSixOneEightBtn = false;
            this.$store.state.activity.showActSixOneEightPop = true;
            MIX.trackPageViewed('ForeverVip618Page');
        },
        clickNewUserActivity() {
            this.$store.state.activity.showActNewUserBtn = false;
            this.$store.state.activity.showActNewUserPop = true;
        }
    }
};
</script>
